// extracted by mini-css-extract-plugin
module.exports = {"modal-heading":"ClientModalChild_modal-heading__2C1Sw","book-from-to":"ClientModalChild_book-from-to__1--ln"};